<template>
  <Vue3Lottie :animationLink='"https://assets7.lottiefiles.com/private_files/lf30_muz3hlyk.json"' :height="100" :width="100" />
</template>

<script>
import Vue3Lottie from 'vue3-lottie'

export default {
  components: {
    Vue3Lottie,
  },
}
</script>